import { dispatchLoaderEvent } from '../../utils/loader'
import { PaymentStatusRouteLoader } from './payment-status-route.types'

export const paymentStatusRouteLoader: PaymentStatusRouteLoader = ({ request }) => {
  const url = new URL(request.url)
  const checkoutSession = url.searchParams.get('checkoutSession')
  dispatchLoaderEvent({ showLoader: false })

  return checkoutSession
}
